import apiService from './v1';

export default apiService;
